import '../styles/Days-forecast.css';

const EightDayForecast = () => {
    return; 
};

export default EightDayForecast; 